import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section id="comprar" className="py-24 bg-olive-green text-white relative overflow-hidden" data-id="element-30">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-31">
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-32"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-33">
        <FadeIn data-id="element-34">
          <div className="max-w-3xl mx-auto mb-12" data-id="element-35">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-6 leading-tight text-warm-beige" data-id="element-36">
              No necesitas otra dieta imposible.
            </h2>
            <p className="text-xl md:text-2xl font-serif mb-8 text-white/90" data-id="element-37">
              Necesitas un sistema simple para comer mejor en la vida real.
            </p>
            <p className="text-lg text-white/80 leading-relaxed max-w-2xl mx-auto" data-id="element-38">
              Sabores que Adelgazan te ayuda a disfrutar más tus comidas,
              reducir el caos de no saber qué comer y mantener el control sin
              sentir que renuncias a todo.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-39">
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 md:p-12 text-center border border-white/20 shadow-2xl max-w-2xl mx-auto" data-id="element-40">
            <p className="text-white/60 text-lg mb-2 line-through decoration-white/40 decoration-2" data-id="element-41">
              Valor total percibido: $27
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-42">
              <span className="text-2xl font-bold text-white" data-id="element-43">
                Oferta especial por esta semana:
              </span>
              <span className="text-6xl font-serif font-bold text-warm-beige" data-id="element-44">
                $11.99
              </span>
            </div>

            <ButtonCTA text="Quiero acceder ahora" href="https://www.tumundoequilibrado.com/cart/51321217220903:1" external={true} className="w-full md:w-auto text-xl px-12 py-5 bg-emerald-500 text-white hover:bg-emerald-600 mb-6" data-id="element-45" />

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-white/80 font-medium text-sm" data-id="element-46">
              <div className="flex items-center" data-id="element-47">
                <Check size={18} className="text-emerald-400 mr-1.5" data-id="element-48" />
                <span data-id="element-49">Acceso inmediato</span>
              </div>
              <div className="hidden sm:block text-white/30" data-id="element-50">•</div>
              <div className="flex items-center" data-id="element-51">
                <Check size={18} className="text-emerald-400 mr-1.5" data-id="element-52" />
                <span data-id="element-53">Formato PDF</span>
              </div>
              <div className="hidden sm:block text-white/30" data-id="element-54">•</div>
              <div className="flex items-center" data-id="element-55">
                <Check size={18} className="text-emerald-400 mr-1.5" data-id="element-56" />
                <span data-id="element-57">Garantía de 7 días</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}